import React from 'react';
import { Sparkles } from 'lucide-react';

interface InstructionAssistantButtonProps {
  agentName: string;
  currentInstructions: string;
  onOpenPanel: () => void;
  disabled?: boolean;
}

const InstructionAssistantButton: React.FC<InstructionAssistantButtonProps> = ({
  agentName,
  currentInstructions,
  onOpenPanel,
  disabled = false,
}) => {
  const hasInstructions = currentInstructions.trim().length > 0;
  const tooltip = hasInstructions
    ? 'Improve instructions with AI'
    : 'Generate instructions with AI';

  return (
    <button
      type="button"
      onClick={onOpenPanel}
      disabled={disabled}
      title={tooltip}
      aria-label={tooltip}
      data-testid="instruction-assistant-button"
      className={`inline-flex items-center justify-center p-1.5 rounded-md transition-colors ${
        disabled
          ? 'text-gray-300 dark:text-gray-600 cursor-not-allowed'
          : 'text-purple-500 hover:text-purple-700 hover:bg-purple-50 dark:text-purple-400 dark:hover:text-purple-300 dark:hover:bg-purple-900/20'
      }`}
    >
      <Sparkles className="w-4 h-4" />
    </button>
  );
};

export default InstructionAssistantButton;
